import React from 'react';
import './index.scss';
import DOMPurify from 'dompurify';

export default function TrendsLabel(props: any) {
  const { text, primary = false, interactable = false, onClick } = props;
  // 默认灰底，primary白底
  return (
    <span
      className={`trends-item-label ${primary ? 'primary' : ''} ${
        interactable ? 'interactable' : ''
      }`}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text),
      }}
      onClick={onClick}
    ></span>
  );
}
